import {debounce} from "lodash";
import {triggerBrandSearch} from "./triggerBrandSearch.js";

export function shouldSearchForBrand(setIsSearching, setBrandSearchKey) {
    return debounce(triggerBrandSearch(setIsSearching, setBrandSearchKey),
        500
    );
}
